import { render, staticRenderFns } from "./blessingSet.vue?vue&type=template&id=2db1f69a&scoped=true&"
import script from "./blessingSet.vue?vue&type=script&lang=js&"
export * from "./blessingSet.vue?vue&type=script&lang=js&"
import style0 from "./blessingSet.vue?vue&type=style&index=0&id=2db1f69a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1f69a",
  null
  
)

export default component.exports